import React from "react";
import { makeStyles } from "@material-ui/core";
import { Room } from "@material-ui/icons";
import moment from "moment";
import Color from "../../../../styles/Color";
import { SelectStatus } from "../components/SelectStatus";

export const useStylesEmergency = makeStyles(theme => ({
    root: {
        display: "flex",
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
    tableStyle: {
        "& .MuiTableBody-root .MuiTableCell-root.MuiTableCell-body": {
            backgroundColor: "#f1f1f17d",
        },
    },
    selectStatus: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
        },
        "&.cancel": {
            background: Color.gray,
            color: "#fefefe",
        },
        "&.complete": {
            background: Color.green,
            color: "#fefefe",
        },
        "&.process": {
            background: Color.secondary,
            color: "#fefefe",
        },
        "&.pending": {
            background: Color.yellow,
            color: "#fefefe",
        },
    },
    ButtonGroupStyle: {
        "& .MuiButton-contained.active": {
            backgroundColor: Color.primary,
            color: "#fff",
        },
    },
}));

export const initialTableOptions = {
    pageSize: 10,
    pageSizeOptions: [10],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    search: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const getColumnsTable = params => {
    return [
        {
            field: "name",
            title: "Name",
        },
        {
            field: "phone",
            title: "Phone",
        },
        {
            align: "center",
            field: "date",
            title: "Time",
            render: obj => {
                return <div>{moment(obj.createdAt).format("H:mm")}</div>;
            },
        },
        {
            align: "center",
            field: "location",
            title: "Location",
            filtering: false,
            render: obj => {
                return (
                    <div onClick={() => params?.handleViewMap(obj)} className={`d-flex align-items-center t-link-blue`}>
                        <Room />
                        <p className="mb-0">
                            {obj.latitude}/{obj.longitude}
                        </p>
                    </div>
                );
            },
        },
        {
            field: "status",
            align: "center",
            title: "Status",
            render: obj => (
                <SelectStatus value={obj.status} onChange={val => params?.handleOnChangeStatus({ obj, val })} disabled={!params?.thisMenuPermission?.edit} />
            ),
        },
    ];
};
